import React from "react";
import { FC } from "react";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import Zoom from "@material-ui/core/Zoom";
import { makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles";
import { createStyles } from "@material-ui/core/styles";
import { Fab } from "@material-ui/core";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";

interface ScrollToTopProps {
  window?: () => Window;
  children?: React.ReactElement;
  threshold?: number;
  disableHysteresis?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: "fixed",
      bottom: theme.spacing(9),
      right: theme.spacing(4),
    },
  }),
);

const DefaultContent = () => (
  <Fab color="primary" size={"small"} aria-label="scroll back to top">
    <KeyboardArrowUpIcon />
  </Fab>
);

const ScrollToTop: FC<ScrollToTopProps> = ({
  disableHysteresis,
  threshold,
  children,
  window,
}) => {
  const classes = useStyles();
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: disableHysteresis,
    threshold: threshold,
  });

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const anchor = (
      (event.target as HTMLDivElement).ownerDocument || document
    ).querySelector("#back-to-top-anchor");

    if (anchor) {
      anchor.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      document?.querySelector("#root")?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <Zoom in={trigger}>
      <div onClick={handleClick} role="presentation" className={classes.root}>
        {children ? children : <DefaultContent />}
      </div>
    </Zoom>
  );
};

export default React.memo(ScrollToTop);
